// extracted by mini-css-extract-plugin
export default {"container":"PoliciesList_container__ulnHj","header":"PoliciesList_header__7HAsx","row":"PoliciesList_row__sn0Ky","rowButton":"PoliciesList_rowButton__MlxZd"};